import React from 'react';

import  AnimalWorld2025  from 'views/AnimalWorld2025';

const DesktopAppPage = () => {
  return <AnimalWorld2025/>;
};
export default DesktopAppPage;
